import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const PrivateRoute: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    // Speichere die ursprünglich angeforderte Route für die Weiterleitung nach dem Login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}; 